/**
 * Custom filter page reset handler
 * Ensures that when any filter is selected, the product list starts from the first product
 * and removes pagination parameters from the URL
 * Supports both 'cp' (custom) and 'page' (Shopify built-in) parameters
 */
(function () {
    'use strict';

    /**
     * Remove pagination parameters from URL and reload
     */
    function removePaginationFromUrl() {
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);
        var hasParams = false;

        // Remove both 'cp' and 'page' parameters
        if (params.has('cp')) {
            params.delete('cp');
            hasParams = true;
        }
        if (params.has('page')) {
            params.delete('page');
            hasParams = true;
        }

        if (hasParams) {
            var newUrl = url.pathname + (params.toString() ? '?' + params.toString() : '');
            window.location.href = newUrl;
        }
    }

    /**
     * Update fb_product_cp content to show page 1
     * Changes "X / Y" to "1 / Y"
     */
    function updateProductCpDisplay() {
        var $cpElement = $('.fb_product_cp');
        if ($cpElement.length > 0) {
            var currentText = $cpElement.text().trim();
            // Match pattern "X / Y" and replace X with 1
            var match = currentText.match(/(\d+)\s*\/\s*(\d+)/);
            if (match) {
                var total = match[2];
                $cpElement.text('1 / ' + total);
            }
        }
    }

    // Wait for DOM to be ready
    $(document).ready(function () {
        // Listen for filter changes
        $(document).on('change', '.filter-group-display__list-item input', function () {
            // Reset page to 0 when filter is changed
            if (typeof theme !== 'undefined' && theme.filter) {
                theme.filter.page = 0;
                theme.filter.productsVisible = theme.filter.productLimit;

                // Reset pagination metadata if available
                if (theme.filter.pagination) {
                    theme.filter.pagination.current_page = 1;
                }
            }

            // Update product count display
            updateProductCpDisplay();

            // Remove pagination parameters from URL
            removePaginationFromUrl();
        });

        // Also reset on price filter changes
        $(document).on('change', 'input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]', function () {
            if (typeof theme !== 'undefined' && theme.filter) {
                theme.filter.page = 0;
                theme.filter.productsVisible = theme.filter.productLimit;

                // Reset pagination metadata if available
                if (theme.filter.pagination) {
                    theme.filter.pagination.current_page = 1;
                }
            }

            // Update product count display
            updateProductCpDisplay();

            // Remove pagination parameters from URL
            removePaginationFromUrl();
        });

        // Handle remove filter button clicks
        $(document).on('click', '.active-filters__remove-filter', function (e) {
            // Remove pagination parameters from URL and reload
            removePaginationFromUrl();
        });

        // Handle any filter.v.option clicks
        $(document).on('click', '[name*="filter.v.option"]', function () {
            // Update product count display
            updateProductCpDisplay();
        });
    });
})();
